import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { AppletAuditTrailContainer } from 'blg-akaun-ts-lib';

export interface AuditTrailState extends EntityState<AppletAuditTrailContainer> {
    selectAgGrid: any;
    selectAuditTrail: AppletAuditTrailContainer;
    errorLog: {timeStamp: Date, log: string}[];
    totalRecords: number,
}

export const auditTrailAdapters: EntityAdapter<AppletAuditTrailContainer> = createEntityAdapter<AppletAuditTrailContainer>({
    selectId: a => a.bl_applet_audit_trail.guid.toString()
});

export const initialState: AuditTrailState = auditTrailAdapters.getInitialState({

    selectAgGrid: null,
    selectAuditTrail: null,
    errorLog: null,
    totalRecords: null,
})
